module.exports = "<div class=\"background\" appSessionTimeout libGoogleTagManager (alertInactivity)='showInactivityModal($event)'>\n    <router-outlet></router-outlet>\n    <bdb-ml-modal #modal (buttonAlertClicked)=\"actionButtomModalBdb($event)\"></bdb-ml-modal>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main